import React from 'react'
import styled from 'styled-components'
import Days from './Days'

class DaySchedule extends React.Component {
    render() {
        const { schedule } = this.props

        return(
            <Side>
             <ScheduleContainer>
               <HoursTitle>Work Hours</HoursTitle>
               { Object.entries(schedule).map((res, i) => {
                   return  <Days key={i} day={res[0]} schedule={schedule[res[0]]}/>
                }) }
             </ScheduleContainer>
            </Side>
        )
    }
}


const Side = styled.div`
    border-bottom: 20px solid #f5f5f5;
`;
const ScheduleContainer = styled.div`
`;
const HoursTitle = styled.div`
  background: #303030;
  color: #fff;
  font-size: 1.6rem;
  margin: 0;
  text-align: center;
  padding: 5px;
`;



export default DaySchedule